export const promises = { 
  readFile: () => Promise.resolve('') 
};
export default { promises };
